import SubmitPortOpeningRequestRuleOnPrem from './SubmitPortOpeningRequestRuleOnPrem';
import CartaId from '../../entities/CartaId';

export default class SubmitPortOpeningRequestOnPrem {

	portOpeningRules!: SubmitPortOpeningRequestRuleOnPrem[];

	direction!: string;

	connectionId!: number;

	contactId!: string;

	businessJustification!: string;

	comments!: string;

	approverId!: string;

	portOpeningRequestOnPremId!: number;

	cartaId!: CartaId[];

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}